import Http from '@/api/http.js'

export default {

  index(filters) {
    return Http.get(`/bills`, {params: {...filters}})
  },
  show(id) {
    return Http.get(`/bills/${id}`);
  },
  create(bill){
    return Http.post(`/bills`, {bill: {...bill}})
  },
  update(bill){
    return Http.put(`/bills/${bill.id}`, {
      bill: {...bill},
    });
  },
  verifyBill(id) {
    return Http.post(`/bills/${id}/verify_bill`);
  },
  baixarBoleto(id) {
    return Http.post(`/bills/${id}/baixar_boleto`);
  },
  generateInGateway(id) {
    return Http.post(`/bills/${id}/generate_in_gateway`);
  },
  generateSecondInstanceInGateway(id) {
    return Http.post(`/bills/${id}/generate_second_instance_in_gateway`);
  },
  protest(id) {
    return Http.post(`/bills/${id}/protest`);
  },

}
